import { Reducer } from 'redux';

import { changeUser } from '#/reduxState/currentUser/currentUserReducer';

import { setRestrictedRegion } from './actions';
import { RegionState } from './types';

type RegionActions =
  | ReturnType<typeof setRestrictedRegion>
  | ReturnType<typeof changeUser>;

// @cached
export const regionReducer: Reducer<RegionState, RegionActions> = (
  state = {
    currentRegion: 'GLOBAL',
    userRegion: 'GLOBAL',
    restrictedRegion: false,
  },
  action
): RegionState => {
  switch (action.type) {
    case 'CHANGE_USER': {
      return { ...state, userRegion: 'GLOBAL' };
      // Changing user is not affecting Geo-blocking currently, but API-catch only
      //   if (!action.loggedIn) {
      //     // at this time we are showing all markets to users that are not logged in although
      //     // this will potentially change in the future
      //     return {
      //       ...state,
      //       userRegion: 'GLOBAL',
      //     };
      //   }
      //   return {
      //     ...state,
      //     userRegion: action.extendedData?.lastRegion || 'GLOBAL',
      //   };
    }
    case 'REGION_SET_RESTRICTED_REGION': {
      return {
        ...state,
        restrictedRegion: action.payload.restrictedRegion,
      };
    }
    default:
      return state;
  }
};
